<template>
  <div
    class="mobile-header common-basic-app-status-bar-padding-top"
    v-show="isMobileSite || alwaysShow"
    :style="{ paddingTop: statusBarHeight + 'px' }"
  >
    <div
      class="fixed"
      :style="[
        {
          color: customColor || '',
          background: customBackgroundColor || '',
          borderBottom: borderBottom || '1px solid #eee'
        },
        { paddingTop: statusBarHeight + 'px' }
      ]"
      ref="fixed"
    >
      <div class="header-left" v-if="!hideLeft">
        <template v-if="isCancel">
          <span class="cancel-btn" @click="goback">取消</span>
          <!--
            v-tap="{ methods: goBack, prevPath: prevPath }"
          -->
        </template>
        <template v-else-if="isCustomText">
          <span class="cancel-btn" @click="goback" v-html="isCustomText"></span>
        </template>
        <template v-else-if="customOpt && customOpt.length > 0">
          <icon
            :name="`${item.icon}`"
            @click="item.method"
            v-for="(item, index) in customOpt"
            :key="item.icon"
            :style="{ left: `${index * 44}px` }"
          />
        </template>
        <template v-else>
          <!--<i class="icon ic-arrow-left" @click="goback"></i>-->
          <icon name="weibiaoti--" @click="goback"></icon>
        </template>
      </div>

      <template>
        <div class="head-middle">
          <h1 v-if="navTitle" class="nav-title">{{ navTitle }}</h1>
          <slot></slot>
        </div>
      </template>

      <template v-if="optBtn">
        <div
          :class="['header-right', { 'header-right-other': pageWidth }]"
          :style="{ width: rightW }"
        >
          <slot v-if="$slots.optBtnRight" name="optBtnRight"></slot>
          <div v-else class="opt-btn" @click="headerOpt" v-html="optTxt"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobileSite: false,
      statusBarHeight: 0
    }
  },

  props: [
    'isCancel',
    'isCustomText',
    'navTitle',
    'prevPath',
    'goback',
    'optBtn',
    'optTxt',
    'headerOpt',
    'customOpt',
    'customColor',
    'customBackgroundColor',
    'borderBottom',
    'alwaysShow',
    'hideLeft',
    'pageWidth',
    'rightW'
  ],

  created() {
    if (this.$platform.isYixinliApp || this.$platform.isZiXunApp) {
      this.isMobileSite = false
    } else {
      this.isMobileSite = true
    }
  },

  mounted() {
    if (this.$platform.isYixinliApp || this.$platform.isZiXunApp) {
      this.$bridge.hasNotch().then(({ statusBarHeight }) => {
        this.statusBarHeight = statusBarHeight

        this.$nextTick(() => {
          const h = this.$refs.fixed.offsetHeight
          this.$emit('initDone', h)
        })
      })
    } else {
      this.$nextTick(() => {
        const h = this.$refs.fixed.offsetHeight
        this.$emit('initDone', h)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-header {
  width: 100%;
  height: 88px;
  .fixed {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    max-width: 750px;
    height: 88px;
    background-color: #118bd0;
    color: #fff;
    z-index: 12;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-left {
      width: 44px;
      white-space: nowrap;
      .icon-node-website {
        display: inline-block;
        width: 88px !important;
        height: 88px;
        line-height: 88px;
        text-align: center;
        color: rgb(51, 51, 51);
        font-size: 32px;
      }
    }
    .cancel-btn {
      display: inline-block;
      height: 88px;
      width: 88px;
      line-height: 88px;
      padding-left: 24px;
      font-size: 28px;
      box-sizing: border-box;
    }
    .ic-arrow-left {
      display: inline-block;
      height: 88px;
      width: 88px;
      background-position: 8px 10px;
      vertical-align: bottom;
    }
    .head-middle {
      flex: 1;
      overflow: hidden;
      .nav-title {
        font-size: 34px;
        line-height: 88px;
        text-align: center;
        padding: 0 112px;
        overflow: hidden;
        height: 88px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .header-right {
      width: 88px !important;
      white-space: nowrap;
      .opt-btn {
        width: 88px;
        height: 88px;
        display: inline-block;
        line-height: 88px;
        padding-right: 24px;
        font-size: 30px;
        text-align: right;
        box-sizing: border-box;
      }
    }
    .header-right-other {
      width: 204px !important;
    }
    /*.header-search {*/
    /*width: 538px;*/
    /*height: 60px;*/
    /*background-color: #ececec;*/
    /*border-radius: 100px;*/
    /*}*/
  }
}
</style>
